import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryInstructionDeliveryCard extends BaseModelAPI {
	static entity = '';
	static entityName = 'deliveryinstructiondeliverycard';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.deliveryCardNumber = '';
			this.partId = '';
			this.part = {};
			this.dcQty = 0;
			this.deliveryInstructionDetailId = '';
			this.deliveryInstructionDetail = {};
			this.deliveryDate = '';
			this.sequence = 0;
			this.totalDeliveryCard = '';
			this.isFullfiled = false;
			this.controlCardStatusId = '';
			this.controlCardStatus = {};
			this.isLoading = false;
			this.deliveryQty = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}